import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

export const CardWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 186px 1fr;
    grid-template-areas:
        'image'
        'content';
    width: 352px;
    height: 410px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    overflow: hidden;
    cursor: auto;

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-rows: 182px 1fr;
        width: 343px;
        height: 399px;
    }
`;

export const CardImage = styled.div`
    position: relative;
    grid-area: image;

    img,
    picture {
        width: 100%;
        height: 100%;
        object-position: center;
        object-fit: cover;
    }
`;

export const ContentWrapper = styled(IndentContainer)`
    grid-area: content;
    background-color: ${COLORS.BgSurface};
`;

export const CardContent = styled(ListContainer)`
    height: 100%;

    ${TextWrapper} {
        align-items: flex-start;

        & > ${H4} {
            ${textOverflowLineClamp(2)};
        }

        & > ${Paragraph4} {
            ${textOverflowLineClamp(3)};
        }
    }

    ${ListContainer} > button:first-child {
        width: 100%;
    }
`;
